import { render, staticRenderFns } from "./Zjxxbglr.vue?vue&type=template&id=6aff9d24"
import script from "./Zjxxbglr.vue?vue&type=script&lang=js"
export * from "./Zjxxbglr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports